module.exports = __webpack_public_path__ + "img/EMPIR-Euramet-Europe.7204d772.jpg";